export const LOADING_STATE = {
  DEMOGRAPHIC_INFO_SAVE: 'DEMOGRAPHIC_INFO_SAVE',
  FETCH_MEMBERSHIP_OFFERINGS: 'FETCH_MEMBERSHIP_OFFERINGS',
  CHECKOUT: 'CHECKOUT',
};
